import SettingsGeneral from './SettingsGeneral';
import SettingsPricing from './SettingsPricing';
import SettingsTaxes from './SettingsTaxes';
import SettingsTierMap from './SettingsTierMap';
import SettingsRentalPeriod from './SettingsRentalPeriod';
import SettingsPayments from './SettingsPayments';
import SettingsCustomFields from './SettingsCustomFields';
import SettingsLocations from './SettingsLocations';
import SettingsEmails from './SettingsEmails';
import SettingsDocuments from './SettingsDocuments';
import SettingsLocale from './SettingsLocale';
import SettingsSecurity from './SettingsSecurity';
import SettingsAccount from './SettingsAccount';
import SettingsAuthnetReview from './SettingsAuthnetReview';
import SaleItems from './SaleItems';
import PageNotFound from './PageNotFound';
import SettingsLayout from './SettingsLayout';

function SettingsContent({ selected }: { selected: string }) {
  switch (selected) {
    case 'general':
      return <SettingsGeneral />;
    case 'pricing':
      return <SettingsPricing />;
    case 'taxes':
      return <SettingsTaxes />;
    case 'tier-map':
      return <SettingsTierMap />;
    case 'rental-period':
      return <SettingsRentalPeriod />;
    case 'payments':
      return <SettingsPayments />;
    case 'authnet-review':
      return <SettingsAuthnetReview />;
    case 'custom-fields':
      return <SettingsCustomFields />;
    case 'locations':
      return <SettingsLocations />;
    case 'emails':
      return <SettingsEmails />;
    case 'documents':
      return <SettingsDocuments />;
    case 'locale':
      return <SettingsLocale />;
    case 'security':
      return <SettingsSecurity />;
    case 'account':
      return <SettingsAccount />;
    case 'sale-items':
      return <SaleItems />;
    default:
      return <PageNotFound />;
  }
}

export default function Settings({ selected }: { selected: string }) {
  // Sale items already renders its own full workspace-card surface (card +
  // inline Header), so it opts out of the shared SettingsLayout shell to avoid
  // nesting two cards/headers.
  if (selected === 'sale-items') {
    return <SaleItems />;
  }
  return (
    <SettingsLayout>
      <SettingsContent selected={selected} />
    </SettingsLayout>
  );
}